<!--固件升级通知 -->
<template>
  <div id="versionIndex">
    <!-- 列表 -->
    <div style="position: relative;">
      <!-- 筛选 -->
      <div class="searchWarp">
        <el-input v-model="searchObj.chargerSn" :placeholder="$t('BondOrUpdateDevice.SN')"
          class="input-with-select deviceNameTable" clearable @clear="changeSearch">
          <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
        </el-input>
        <el-button class="filter-item" type="primary" icon="el-icon-plus" style="float: right;margin-right: 20px;"
          @click="add" />
      </div>
      <el-table id="versionIndexTable" v-loading="loading" :data="tableData" style="width: 100%" border>
        <el-table-column prop="chargerSn" :label="$t('BondOrUpdateDevice.SN')" align="center" />
        <el-table-column prop="typeZh" :label="$t('AllDevices.Type')" align="center" width="100"/>
        <el-table-column prop="configTimeZh" :label="$t('warningPage.CreatedAt')" align="center" />
        <el-table-column prop="fileName" :label="$t('adminView.File')" align="center" />
        <el-table-column prop="fileVersionZh" :label="$t('adminView.SystemVersion')" align="center" width="100" />
        <el-table-column prop="remark" :label="$t('warningPage.Remark')" show-overflow-tooltip align="center" />
        <el-table-column prop="updateBy" :label="$t('QR.Uploader')" align="center" width="100" />
        <el-table-column prop="" :label="$t('yhubReport.Operating')" align="center">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="edit(scope.row)" />
              <el-button type="primary" icon="el-icon-delete" size="mini" @click="deleteVersion(scope.row)" />
              <!-- <el-button type="primary" size="mini" @click="gotoUpdateInfo(scope.row)">最后更新信息</el-button>
              <el-button type="primary" size="mini">充电器充电日志</el-button>
              <el-button type="primary" size="mini">曲线更新日志</el-button>
              <el-button type="primary" size="mini">版本管理</el-button> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination v-if="pageshow" background current-page.sync="listQuery.pageInfo.page"
            :page-sizes="listQuery.pageInfo.pageList" :page-size="listQuery.pageInfo.limit"
            layout="total, sizes, prev, pager, next, jumper" :total="listQuery.pageInfo.total"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
    <!-- 新增/编辑--弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowPop" width="80%">
      <el-form ref="dataForm" :rules="rules" :model="popObj" label-position="right" label-width="180px"
        style="width: 80%;max-width: 600px;margin-left: 50px;">
        <el-form-item :label="$t('AllDevices.SearchDeviceSn')" prop="chargerSn">
          <el-input v-model="popObj.chargerSn" :disabled="!isAdd" :autosize="{ minRows: 4, maxRows: 8}"
            :placeholder="$t('adminView.PleaseEnterSN')" style="width: 100%" type="textarea" @input="change"
            :title="$t('adminView.PleaseEnterSN')" />
        </el-form-item>
        <el-form-item :label="$t('adminView.File')" prop="fileName">

          <el-input v-model="popObj.fileName" :disabled="true" class="fl" style="width: 340px;" />
          <!-- <el-radio v-model="popObj.type" :disabled="!isAdd" :label="1">{{ $t('AllDevices.charger') }}</el-radio>
          <el-radio v-model="popObj.type" :disabled="!isAdd" :label="2">{{ $t('AllDevices.BatteryMonitor') }}</el-radio> -->

          <!-- 选择版本 -->
          <el-button class="fr" type="primary" @click="selectFW">{{ $t('adminView.select') }}</el-button>

        </el-form-item>
        <el-form-item :label="$t('adminView.Version')" prop="fileVersion">
          <el-input v-model="popObj.fileVersion" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('warningPage.Remark')">
          <el-input v-model="popObj.remark" :autosize="{ minRows: 4, maxRows: 8}"
            :placeholder="$t('warningSet.Pleaseenter')" style="width: 100%" type="textarea" @input="change" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button @click="isShowPop=false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" @click="confirmPop('dataForm')">{{ $t('button.Confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 选择版本弹窗 -->
    <el-dialog v-loading="loadingFw" :close-on-click-modal="false" :title="$t('adminView.FirmwareVersion')"
      :visible.sync="isShowFwPop" width="70%">

      <el-radio-group v-model="popObj.type" @change="selectFW(true)" style="margin-bottom: 20px;">
        <el-radio v-for="item in versionTypeList" :disabled="!isAdd" :label="item.type">
          {{typeNameHandle(item.type)}}
        </el-radio>

      </el-radio-group>

      <el-table :data="fwList" border fit highlight-current-row>
        <el-table-column :label="$t('adminView.File')" prop="deviceName" align="center" />
        <el-table-column :label="$t('adminView.FirmwareVersion')" prop="deviceModel" align="center" />
        <el-table-column :label="$t('adminView.Version')" prop="deviceVersion" align="center" />
        <el-table-column :label="$t('warningPage.Remark')" prop="remark" align="center" show-overflow-tooltip />
        <el-table-column :label="$t('yhubReport.Operating')" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="sureFW(scope.row)">{{ $t('adminView.select') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination v-if="pageshow2" background current-page.sync="listQuery.pageInfo.page"
            :page-sizes="listQuery2.pageInfo.pageList" :page-size="listQuery2.pageInfo.limit"
            layout="total, sizes, prev, pager, next, jumper" :total="listQuery2.pageInfo.total"
            @size-change="handleSizeChange2" @current-change="handleCurrentChange2" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { chargerFirmwareVersionNotify, add, update, deleteNotify } from '@/api/blueTooth'
import { pageDeviceSystemVersionList } from '@/api/firmwareUpdate'
import { pagination } from '@/utils/init_table'
import i18n from '@/i18n'
import { getDateAndHour } from '@/utils/updateTime.js'
import { getVersionConfig } from '@/api/index'

export default {
  data () {
    return {
      // 分页----start
      listQuery: {
        fileVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end,
      // 分页----start
      listQuery2: {
        fileVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow2: true,
      // 分页----end
      loading: true,
      loadingFw: true,
      searchObj: {},
      tableData: [],
      isShowPop: false, // 新增/编辑弹窗
      popObj: {
        type: 1,
        chargerSn: null,
        fileName: null,
        fileVersion: null
      },
      rules: {
        chargerSn: [{ required: true, message: i18n.t('lease.Cannotbeblanked'), trigger: 'blur' }], // 序列号不能为空
        fileName: [{ required: true, message: i18n.t('lease.Cannotbeblanked'), trigger: 'blur' }], // 序列号不能为空
        fileVersion: [{ required: true, message: i18n.t('lease.Cannotbeblanked'), trigger: 'blur' }] // 序列号不能为空
      },
      isAdd: true,
      isShowFwPop: false, // 固件版本弹窗
      fwList: [],// 固件版本列表
      versionTypeList: []
    }
  },
  watch: {
    language (newValue, oldValue) {
      this.rules.chargerSn[0].message = this.rules.fileName[0].message = this.rules.fileVersion[0].message = i18n.t('lease.Cannotbeblanked2')
      this.queryList()
    }
  },
  created () {
    this.queryList()

    this.getVerConfig()
  },
  methods: {
    typeNameHandle (type) {
      if (type == 1) return this.$t('AllDevices.charger')
      if (type == 2) return this.$t('AllDevices.BatteryMonitor')
      return type
    },
    getVerConfig () {
      getVersionConfig().then(res => {
        console.log('固件版本配置：', res)
        if (res.resultModel) {
          this.versionTypeList = res.resultModel
        }

      })
    },
    queryList () {
      var param = {
        'chargerSn': this.searchObj.chargerSn,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      this.loading = true
      chargerFirmwareVersionNotify(param).then(res => { // 基本信息
        this.loading = false
        if (res.resultCode === 1001 && res.resultModel) {
          // console.log(res.resultModel)
          this.tableData = res.resultModel.list
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          this.tableData.forEach((v, i) => {
            if (v.configTime) v.configTimeZh = getDateAndHour(v.configTime)
            v.fileVersionZh = v.fileVersion
            for (var i = 0; i < 3 - v.fileVersion.length; i++) {
              v.fileVersionZh = '0' + v.fileVersionZh
            }
            v.typeZh = v.type == 1 ? i18n.t('AllDevices.charger') : i18n.t('AllDevices.BatteryMonitor')// 1 充电器、2yhub
            v.fileVersionZh = 'V' + v.fileVersionZh
          })
        }
      })
    },
    add () { // 新增
      this.isShowPop = this.isAdd = true
      for (var attr in this.popObj) this.popObj[attr] = null
      this.popObj.type = 1
    },
    edit (row) { // 编辑
      this.isShowPop = true
      this.isAdd = false
      for (var attr in row) this.popObj[attr] = row[attr]
    },
    deleteVersion (row) { // 删除
      this.$confirm('是否确定删除本条数据？', '', {// '此操作将永久删除该记录, 是否继续?'
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        deleteNotify({ 'id': row.id }).then(response => {
          if (response.resultCode === 1001) {
            this.itemIds = null
            this.queryList()
            this.$notify({
              title: '',
              message: i18n.t('lease.Succeed'),
              type: 'success',
              duration: 2000
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: i18n.t('adminView.Canceled')// '已取消删除'
        })
      })
    },
    confirmPop (formName) { // 提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var param = {
            chargerSn: this.popObj.chargerSn,
            fileName: this.popObj.fileName,
            fileVersion: this.popObj.fileVersion,
            remark: this.popObj.remark,
            status: 0,
            updateBy: this.$store.state.userInfo.userLoginName,
            type: this.popObj.type
          }
          //如果sn包含all但又不等于all，提示错误
          if (this.popObj.chargerSn.indexOf("all") != -1 && this.popObj.chargerSn != 'all') {
            this.$message({
              type: 'error',
              message: i18n.t('adminView.SNError')// '已取消删除'
            })
            return
          }

          if (this.isAdd) { // 新增
            add(param).then(res => {
              if (res.resultCode === 1001) {
                this.$message({
                  type: 'success',
                  message: i18n.t('lease.Succeed')
                })
                this.isShowPop = false
                this.queryList()
              }
            })
          } else {
            param.id = this.popObj.id
            param.configTime = this.popObj.configTime
            update(param).then(respone => {
              if (respone.resultCode === 1001) {
                this.$message({
                  type: 'success',
                  message: i18n.t('lease.Succeed')
                })
                this.isShowPop = false
                this.queryList()
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getTypeParam (type) {
      console.log(type)
      let array = this.versionTypeList
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element.type == type) return element.param
      }
      return ''
      // this.versionTypeList.forEach(item => {
      //   if (item.type == type) return item.param
      // })
    },
    selectFW (bool = false) { // 选择固件--打开固件版本弹窗
      if (bool) {
        this.listQuery2.pageInfo.pageNum = 1
      }
      this.isShowFwPop = true
      var param = {
        'deviceModel': '',
        'pageNum': this.listQuery2.pageInfo.pageNum,
        'pageSize': this.listQuery2.pageInfo.pageSize
      }
      param.deviceModel = this.getTypeParam(this.popObj.type)
      //this.popObj.type == 1 ? 'CHARGER12,C0103,C0203,C0102' : 'YHUB11,YHUB12,YhubLite'
      this.loadingFw = true
      pageDeviceSystemVersionList(param).then(res => {
        this.loadingFw = false
        this.fwList = res.resultModel.list
        this.listQuery2.pageInfo.total = res.resultModel.total // 分页
        this.fwList.forEach(v => {
          v.updateTime = getDateAndHour(new Date(v.createTime).getTime())
        })
      })
    },
    sureFW (row) { // 选中固件版本
      this.isShowFwPop = false
      this.popObj.fileName = row.deviceName
      this.popObj.fileVersion = row.deviceVersion
      this.popObj.remark = row.remark
    },
    // 筛选改变事件
    changeSearch () {
      if (this.searchObj.chargerSn) {
        // 去掉首尾空格
        this.searchObj.chargerSn = this.searchObj.chargerSn.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      }
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    change (e) {
      this.$forceUpdate()
    },
    // 分页----start
    handleSizeChange (val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange (val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    // 分页----end
    // 分页----start
    handleSizeChange2 (val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery2.pageInfo.pageSize = val
      this.selectFW()
    },
    handleCurrentChange2 (val, e) { // 选中某一页
      this.listQuery2.pageInfo.pageNum = val
      this.selectFW()
    }
    // 分页----end

  }
}
</script>
<style lang="scss">
#versionIndex {
  background: #fff;
  padding: 13px 20px;
  .searchWarp {
    margin-bottom: 10px;
  }
  .searchWarp .el-input-group {
    width: 40% !important;
    max-width: 400px !important;
    margin-top: 13px;
  }
  #versionIndexTable .el-button {
    margin: 5px 0;
  }
}
</style>
